import React from "react";
import { useSmartNavigate } from "@/hooks";
import { Button, Result } from "antd";
import styles from "./index.module.css";

const ErrorPage = ({ errorType = "404" }: { errorType: "404" | "empty" }) => {
  const navigate = useSmartNavigate();

  return (
    <div className={styles.container}>
      {errorType === "empty" ? (
        <Result
          status="404"
          title="空应用"
          subTitle="您访问的应用没有任何页面"
          extra={
            <>
              <Button
                type="primary"
                onClick={() => {
                  window.location.reload();
                }}
              >
                刷新
              </Button>
            </>
          }
        />
      ) : (
        <Result
          status="404"
          title="404"
          subTitle="抱歉，您访问的页面不存在"
          extra={
            <>
              <Button
                // disabled={window.history?.state?.idx <= 0}
                type="primary"
                onClick={() => navigate(-1)}
              >
                返回
              </Button>
              <Button
                onClick={() => {
                  window.location.href = "/";
                }}
              >
                去主页
              </Button>
            </>
          }
        />
      )}
    </div>
  );
};

export default ErrorPage;
